import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { registerService } from "../../services/services";
import { toastError, toastSuccess } from "../../utils";
import useInput from "../../hooks/useInput";
import { Eye, EyeOff } from "lucide-react";

const Register = () => {
  const name = useInput("");
  const phone = useInput("");
  const email = useInput("");
  const password = useInput("");

  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const validate = () => {
    let newErrors = {};

    // Name
    if (!name.value.trim()) newErrors.name = "Full name is required";

    // Phone
    if (!phone.value.trim()) {
      newErrors.phone = "Phone number is required";
    } else if (!/^\d{10}$/.test(phone.value)) {
      newErrors.phone = "Phone number must be 10 digits";
    }

    // Email
    if (!email.value.trim()) {
      newErrors.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value)) {
      newErrors.email = "Enter a valid email address";
    }

    // Password
    if (!password.value.trim()) newErrors.password = "Password is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validate()) return;

    const payload = {
      name: name.value,
      phone: phone.value,
      email: email.value,
      password: password.value,
    };

    const fetchApi = async () => {
      try {
        const response = await registerService(payload);
        toastSuccess(response.data.message);
        navigate("/login");
      } catch (error) {
        toastError(error.response?.data?.message || "Registration failed");
      }
    };
    fetchApi();
  };

  return (
    <div className="container">
      <div
        className="row justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <div className="col-xl-5 col-lg-8 col-md-9">
          <div className="text-center my-4">
            <h1 className="ab-brand">
              Assit Buddi <span>Book</span>
            </h1>
            <p className="text-muted">Your personal money management system</p>
          </div>

          <div className="card auth-card o-hidden border-0 shadow-lg my-5">
            <div className="auth-header py-3 text-center">
              <h4 className="mb-0">Create an Account!</h4>
            </div>

            <div className="card-body px-3 py-5 p-md-5">
              <form onSubmit={handleSubmit} className="user">
                {/* Full Name */}
                <div className="mb-3">
                  <input
                    type="text"
                    name="name"
                    className={`form-control form-control-user ${
                      errors.name ? "is-invalid" : ""
                    }`}
                    placeholder="Full Name"
                    {...name}
                  />
                  {errors.name && (
                    <div className="invalid-feedback">{errors.name}</div>
                  )}
                </div>

                {/* Phone Number */}
                <div className="mb-3">
                  <input
                    type="text"
                    name="phone"
                    className={`form-control form-control-user ${
                      errors.phone ? "is-invalid" : ""
                    }`}
                    placeholder="Phone Number"
                    maxLength="10"
                    {...phone}
                  />
                  {errors.phone && (
                    <div className="invalid-feedback">{errors.phone}</div>
                  )}
                </div>

                {/* Email */}
                <div className="mb-3">
                  <input
                    type="email"
                    name="email"
                    className={`form-control form-control-user ${
                      errors.email ? "is-invalid" : ""
                    }`}
                    placeholder="Email Address"
                    {...email}
                  />
                  {errors.email && (
                    <div className="invalid-feedback">{errors.email}</div>
                  )}
                </div>

                {/* Password with Eye Toggle */}
                <div className="mb-3 position-relative">
                  <input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    className={`form-control form-control-user ${
                      errors.password ? "is-invalid" : ""
                    }`}
                    placeholder="Password"
                    {...password}
                  />
                  <span
                    className="position-absolute"
                    onClick={() => setShowPassword(!showPassword)}
                    style={{
                      right: "15px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                    }}
                  >
                    {showPassword ? (
                      <EyeOff size={20} color="#666" />
                    ) : (
                      <Eye size={20} color="#666" />
                    )}
                  </span>
                  {errors.password && (
                    <div className="invalid-feedback">{errors.password}</div>
                  )}
                </div>

                <div className="text-end mt-4">
                  <button
                    type="submit"
                    className="btn btn-primary btn-user btn-block w-100"
                  >
                    Register Account
                  </button>
                </div>
              </form>

              <hr />
              <div className="text-center">
                <Link className="auth-link small" to="/login">
                  Already have an account? Login!
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
